import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'program-detail-service-type';

// services
export const flatServicesPropType = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string.isRequired,
  parent_id: PropTypes.string,
  parent_code: PropTypes.string,
  name: PropTypes.string,
  code: PropTypes.string,
  taxonomy: PropTypes.string,
  is_sensitive: PropTypes.bool
}));
function getIcon(code) {
  switch (code) {
    case 'UU-BENEFITS':
      return 'Benefits';
    case 'UU-CLOTHING':
      return 'ClothingHouseholdGoods';
    case 'UU-EDUCATION':
      return 'Education';
    case 'UU-EMPLOYMENT':
      return 'Employment';
    case 'UU-ENTREPRENEURSHIP':
      return 'Entrepreneurship';
    case 'UU-FOOD':
      return 'Food';
    case 'UU-HEALTH':
      return 'MedicalHealth';
    case 'UU-INCOME-SUPPORT':
      return 'IncomeSupport';
    case 'UU-HOUSING':
      return 'HousingShelter';
    case 'UU-SUPPORT-SERVICES':
      return 'IndvFamSupport';
    case 'UU-LEGAL':
      return 'Legal';
    case 'UU-MEDICAL-HEALTH':
      return 'MedicalHealth';
    case 'UU-MENTAL-BEHAVIORAL-HEALTH':
      return 'MentalHealth';
    case 'UU-MONEY-MANAGEMENT':
      return 'MoneyManagement';
    case 'UU-SOCIAL-ENRICHMENT':
      return 'PersonalEnrichment';
    case 'UU-SPIRITUAL':
      return 'SpiritualEnrichment';
    case 'UU-SPORTS':
      return 'SportsRecreation';
    case 'UU-SUBSTANCE-USE':
      return 'Substance';
    case 'UU-TRANSPORTATION':
      return 'Transportation';
    case 'UU-UTILITIES':
      return 'Utilities';
    case 'UU-WELLNESS':
      return 'Wellness';
    default:
      return 'LogoShield';
  }
}
function Services(_ref) {
  let {
    showIcon,
    services
  } = _ref;
  // Get parent service types
  const mappedServices = services.filter(service => !service.parent_id).map(service => ({
    id: service.id,
    name: service.name,
    code: service.code
  }));
  // Attach children service names to parents
  mappedServices.forEach(parent => {
    // eslint-disable-next-line no-param-reassign
    parent.children = services.filter(child => child.parent_id === parent.id).map(child => ({
      id: child.id,
      name: child.name
    }));
  });
  return mappedServices.map(ms => {
    // eslint-disable-line arrow-body-style
    return /*#__PURE__*/_jsxs("div", {
      className: "m-4",
      children: [/*#__PURE__*/_jsxs("h3", {
        className: "".concat(DISPLAY_NAME, "-list-type font-medium-font mb-2 text-dark-blue"),
        children: [showIcon && /*#__PURE__*/_jsx(Icon, {
          icon: getIcon(ms.code),
          className: "mr-1",
          color: "#525F73"
        }), ms.name]
      }, ms.id), /*#__PURE__*/_jsx("ul", {
        className: "".concat(DISPLAY_NAME, "-list list-disc ml-4 pl-1"),
        children: ms.children.map(child => /*#__PURE__*/_jsx("li", {
          className: "".concat(DISPLAY_NAME, "-list-item leading-5"),
          children: child.name
        }, child.id || window.crypto.randomUUID))
      })]
    }, ms.id);
  });
}
Services.propTypes = {
  services: flatServicesPropType.isRequired,
  showIcon: PropTypes.bool
};
Services.defaultProps = {
  showIcon: true
};
export default Services;
//# sourceMappingURL=Services.js.map